<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>大额充值复审</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-tabs :value="activeTab" @tab-click="handleDepositTabChange">
        <el-tab-pane label="所有" name="1"></el-tab-pane>
      </el-tabs>
      <div class="page-actions">
        <el-autocomplete
          class="inline-input"
          v-model="selectedCoin"
          :fetch-suggestions="querySearch"
          placeholder="请输入币种"
          @select="handleSelect"
          @keyup.native.enter="handleSearch">
          <i
            class="el-icon-close el-input__icon"
            slot="suffix"
            @click="cleanSearchCoin"
            style="cursor:pointer;">
          </i>
        </el-autocomplete>
        <el-input placeholder="请输入账号ID" clearable v-model="userId" @keyup.native.enter="handleSearch">>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入充值地址" clearable v-model="walletAddres" @keyup.native.enter="handleSearch">>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入充值地址memo" clearable v-model="memo" @keyup.native.enter="handleSearch">>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <audit-list @refresh="getList"></audit-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import AuditList from './components/list';
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'depositCheck',
  data() {
    return {
      selectedCoin: '',
      nowCoin: '',
      userId: '',
      walletAddres: '',
      memo: ''
    };
  },
  components: {
    AuditList
  },
  computed: {
    ...mapState('depositCheck', [
      'activeTab',
      'chooseCoinType',
      'allCoins',
      'pagination'
    ])
  },
  methods: {
    cleanSearchCoin() {
      this.selectedCoin = '';
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.allCoins;
      results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = this.allCoins;
      return (tempData) => {
        return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    ...mapMutations('depositCheck', ['changeTab']),
    ...mapActions('depositCheck', [
      'list',
      'listCoinType',
      'listBillType',
      'getAllCoins',
      'changeCoinType'
    ]),
    handleSelect(tab) {
      this.changeTab(tab.name);
    },
    handleDepositTabChange(tab) {
      this.changeTab(tab.name);
      this.getList({
        page: 1
      });
    },
    getList(data = {}) {
      this.list({
        userId: this.userId,
        txStatus: 8,
        txDepositStatus: '',
        walletAddres: this.walletAddres,
        memo: this.memo,
        coinType: this.selectedCoin.toUpperCase(),
        ...this.pagination,
        ...data
      });
    },
    handleSearch() {
      this.getList({
        page: 1
      });
    }
  },
  watch: {
    nowCoin(val) {
      this.changeCoinType(val);
      this.getList({
        page: 1
      });
    }
  },
  created() {
    this.getAllCoins();
    this.getList();
  }
};
</script>

<style lang="less">
.user-deposit-link {
  color: #409eff;
  .cell {
    span {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.user-deposit-records-wrap {
  .el-table {
    .cell {
      font-size: 12px;
      text-align: center;
    }
  }
  .user-deposit-pager-wrap {
    text-align: right;
    margin: 10px 0px;
  }
}
</style>
